import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=5f2bdc82&scoped=true&lang=css"

import exportComponent from "C:\\vue2023\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f2bdc82"]])

export default __exports__